import { render, staticRenderFns } from "./settingJurisdictionApply1.vue?vue&type=template&id=2980cfbd&scoped=true"
import script from "./settingJurisdictionApply1.vue?vue&type=script&lang=js"
export * from "./settingJurisdictionApply1.vue?vue&type=script&lang=js"
import style0 from "./settingJurisdictionApply1.vue?vue&type=style&index=0&id=2980cfbd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2980cfbd",
  null
  
)

export default component.exports